
import { MenuItem, FormControl, Select, useTheme, useMediaQuery } from '@mui/material';
import { GlobalData } from '../util/GlobalData';

export const CurrencySelectorComponent = ({ currency, handleCurrencyChange, blackStyle, selectStyle = {}, fullWidth = false }) => {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('lg'));


    return (
        <FormControl variant="outlined" fullWidth={fullWidth}>
            <Select
                value={currency}
                onChange={handleCurrencyChange}

                sx={{
                    border: '1px solid',
                    borderColor: (isSmallScreen || blackStyle) ? '#000' : '#fff',

                    '& .MuiSelect-select': {
                        color: (isSmallScreen || blackStyle) ? '#000' : '#fff',
                        fontWeight: "bold"
                    },
                    ...selectStyle
                }}
            >
                {Object.keys(GlobalData.currency).map((curr) => {
                    return (
                        <MenuItem key={curr} value={curr}>
                            {GlobalData.currency[curr]} {curr} - {GlobalData.currencyName[curr]}
                        </MenuItem>
                    )
                })}
            </Select>
        </FormControl>
    );
};